import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'

// state
const state = {
	resetTable: false, //set to true to reset to first page on ajax reload,
	tableRefreshMsg: '',
}

const getters = {
}


// mutations
const mutations = {
	TOGGLE_BOOLEAN_STATE(state, {key, bool}){
		eval('state.' + key + ' = bool');
	},

	SET_MESSAGE (state, {key, message}){
		eval('state.' + key + ' = message');
	},
}

// actions
const actions = {
	setBoolean({commit}, {key, bool}){
		commit('TOGGLE_BOOLEAN_STATE', {key: key, bool: bool});
	},

	resetDatatable({commit, dispatch, state, rootState}){
		//console.log("reset datatable");
	    var refreshTable = rootState.requests.tableRefresh;

	   	// refresh vendor statistics
	   	VueStore.dispatch('stats/getVendorStats');

	    if( typeof refreshTable !== 'undefined'){
	        var table = `#${refreshTable}`;

	        if(state.resetTable){
		        $(table).DataTable().ajax.reload(); //reset to page 1.
		        //commit('TOGGLE_BOOLEAN_STATE', {key: 'resetTable', bool: false})
	        } else {
		        $(table).DataTable().ajax.reload(null, false); //do not reset to page 1.
	        }

	        dispatch('getTableTimeStamp');
	    }
	},

	getTableTimeStamp({commit, state}){
        var now = moment().format('LT');
        var message = 'Last refreshed at '+now;
        //console.log(message);
        commit('SET_MESSAGE', {key: 'tableRefreshMsg', message: message});
	}

}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}